import Charts from '@component/echarts'
import { map, size } from 'lodash-es'
import { graphic } from 'echarts'
import { getTime, toNumber, toPrice } from '@utils'
export default function OverTime({
  data
}) {

  const { avm, median, rv } = data
  const series = []
  if (size(avm) > 0) {
    series.push(getSeries(map(avm, item => [toNumber(item.month), toNumber(item.avm)]), 'Estimate', '255,133,0'))
  }
  if (size(median) > 0) {
    series.push(getSeries(map(median, item => [toNumber(item.month), toNumber(item.suburbMedianAvm)]), 'Suburb median', '89,32,166'))
  }
  if (size(rv) > 0) {
    series.push(getSeries(map(rv, item => [toNumber(item.month), toNumber(item.rv)]), 'RV', '255,208,83'))
  }
  series.sort((p, n) => n.data.length - p.data.length)

  const options = {
    legend: {
      left: 'center',
      bottom: 10,
      textStyle: {
        fontSize: 14,
        color: '#7B7B7B'
      },
      icon: 'rect',
      itemWidth: 20,
      itemHeight: 20,
      itemGap: 20,
      data: ['RV', 'Estimate', 'Suburb median']
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#FFF',
      textStyle: {
        color: '#7B7B7B'
      },
      formatter(v) {
        let str = []
        v.forEach(item => {
          let p = parseFloat(item.value[1])
          str.push(`<div style="text-align: center;"><span style="color: ${item.color};">${item.seriesName}:</span> ${toPrice(p)}</div>`)
        })
        return str.join('')
      }
    },
    grid: {
      top: '2%',
      left: '2%',
      right: '2%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLabel: {
        formatter(v) {
          let year = v.substr(0, 4)
          let month = v.substr(4, 2)
          let now = new Date(`${year}/${month}/01`)
          return `${getTime(now.getTime() / 1000, 'MMM')}\n${year}`
        }
      }
    },
    yAxis: {
      type: 'value',
      splitLine: {
        lineStyle: {
          color: '#F0F1F3'
        }
      },
      axisLabel: {
        formatter(v) {
          return toPrice(v)
        }
      }
    },
    series
  }

  return (
    <section className='h-400 border rounded-b-sm pt-20 px-10 md:pt-0 md:px-0 md:border-0'>
      <Charts options={options}></Charts>
    </section>
  )
}

function getSeries(data, name, color) {
  return {
    name,
    data,
    type: 'line',
    lineStyle: {
      color: `rgb(${color})`
    },
    smooth: true,
    itemStyle: {
      color: `rgb(${color})`
    },
    areaStyle: {
      color: new graphic.LinearGradient(0, 0, 0, 1, [{
        offset: 0,
        color: `rgba(${color}, 0.29)`
      }, {
        offset: 1,
        color: `rgba(${color}, 0)`
      }])
    }
  }
}